export const searchDropdown =  [
	{
	  title: "Dim Divisor Name",
	  value: "dimName"
	},
	{
		title: "Retailer Name",
		value: "rtlName"
	}
]


// WEBPACK FOOTER //
// ./src/pages/dimdivisor/filter/searchDropdown.js